@if (widget()?.assetClass === assetClassEnum.US_EQUITY) {
	<app-dropdown-columns-actions
		[columns]="stocksColumns()"
		[translationPrefix]="'positions.'"
		(columnsChange)="onChangeStocksColumns($event)"
	/>
} @else {
	<app-dropdown-columns-actions
		[columns]="optionsColumns()"
		[translationPrefix]="'positions.'"
		(columnsChange)="onChangeOptionsColumns($event)"
	/>
}
